exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable {\n  cursor: pointer; }\n\n.maintenance-container:not(:first-of-type) {\n  margin-top: 0.5rem;\n  border-top: 0.0625rem solid rgba(0, 0, 0, 0.1);\n  padding-top: 0.5rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/header/header.component.scss
// module id = 970
// module chunks = 1